import React from 'react';
import styled from 'styled-components';
import { SVGIcon } from '../../../BuildingBlocks/SVGIcon';
import { Grid } from '../../../Utility/Grid';

export const StyledIcon = styled((props) => {
  const { selectedIcon } = props;
  return (
    <div style={{ textAlign: 'center' }}>
      <SVGIcon selectedIcon={selectedIcon} />
    </div>
  );
})``;

export const NoDataContainer = styled(Grid.Container)`
  margin-top: 88px;
`;
